import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

export const saveModule = (module) => ({
    type: actionTypes.SAVE_MODULE,
    payload: {
        module: module
    }
});

export const changeModule = (module) => ({
    type: actionTypes.CHANGE_MODULE,
    payload: {
        module: module
    }
});

export const changeSoftwareType = (type) => ({
    type: actionTypes.CHANGE_SOFTWARE_TYPE,
    payload: {
        type: type
    }
});

export const setIdentifier = (identifier) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SET_CLIENT_IDENTIFIER,
        params: {
            clientIdentifier: identifier
        }
    },
    method: handlers.SET_CLIENT_IDENTIFIER,
    tabId: 0
});

export const setWinterPlugin = (active) => ({
    type: actionTypes.PLUGINS_SET_WINTER,
    payload: {
        active: active
    }
});

export const reloadWinterTime = () => ({
    type: actionTypes.PLUGINS_RELOAD_WINTER_TIME
});
